import API from './settings'
import { TicketMultipleCloseFormModel, TicketMultipleUpdateFormModel } from '../models/ticket.model';
import { DataCustomField } from '../models/customField.model';
import { APIResponseModel } from '../models/api-call';

export const createTicket = (project_code: string, formData: any): any => {
    return API.post(`${project_code}/ticket/create`, formData);
};

export const getTicket = (project_code: string, ticket_number: string): any => {
    return API.get(`${project_code}/ticket/get/${ticket_number}`);
};

export const filterTickets = (project_code: string, formData: any): any => {
    return API.post(`${project_code}/ticket/filter`, formData);
};

export const closeTicket = (project_code: string, ticket_number: string, formData: any): any => {
    return API.post(`${project_code}/ticket/close/${ticket_number}`, formData);
};

export const closeMultipleTickets = (project_code: string, formData: TicketMultipleCloseFormModel): any => {
    return API.post(`${project_code}/ticket_close/multiple`, formData)
}

export const updateMultipleTickets = (project_code: string, formData: TicketMultipleUpdateFormModel): any => {
    return API.post(`${project_code}/ticket/update/multiple`, formData)
}

export const createTicketUpdate = (project_code: string, ticket_number: string, formData: any): any => {
    return API.post(`${project_code}/ticket/update/create/${ticket_number}`, formData);
};

export const getTicketUpdates = (project_code: string, ticket_number: string): any => {
    return API.get(`${project_code}/ticket/update/all/${ticket_number}`);
};

export const getTicketUpdate = (project_code: string, ticket_number: string, update_number: string): any => {
    return API.get(`${project_code}/ticket/update/get/${ticket_number}/${update_number}`);
};

export const getTicketClose = (project_code: string, ticket_number: string): any => {
    return API.get(`${project_code}/ticket/close/get/${ticket_number}`);
};

export const getSLAIndicators = (project_code: string): any => {
    return API.get(`${project_code}/ticket/need_update/get`);
};

export const getAssignationIndicators = (project_code: string): any => {
    return API.get(`${project_code}/ticket/assignation/get`);
};

export const editTicket = (project_code: string, ticket_number: string, formData: any): any => {
    return API.post(`${project_code}/ticket/edit/${ticket_number}`, formData);
};

export const editTicketAlarms = (project_code: string, ticket_number: string, formData: any): any => {
    return API.post(`${project_code}/ticket/alarms/edit/${ticket_number}`, formData);
};

export const getTicketCustomFieldsForm = (project_code: string): any => {
    return API.get(`${project_code}/ticket/get_custom_fields`);
};


export const filterTicketCustomFields = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/custom_field/ticket/filter`, formData);
}

export const getTicketCustomField = (project_code: string, cf_code: string): any => {
    return API.get(`/${project_code}/custom_field/ticket/get/${cf_code}`);
};

export const createTicketCustomField = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/custom_field/ticket/create`, formData);
};

export const editTicketCustomField = (project_code: string, cf_code: string, formData: any): any => {
    return API.post(`/${project_code}/custom_field/ticket/edit/${cf_code}`, formData);
};

export const deleteTicketCustomField = (project_code: string, cf_code: string, formData: any = {}): any => {
    return API.post(`/${project_code}/custom_field/ticket/delete/${cf_code}`, formData);
};

